module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter"
    }
  }, [_c('header', [_c('h1', {
    staticClass: "topictitle1",
    attrs: {
      "id": "ep2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/nav#nep2"
    }
  }, [_c('span', {
    staticClass: "first_text"
  }, [_vm._v("Epigraph")])])])]), _vm._v(" "), _c('div', {
    staticClass: "epi_group"
  }, [_c('p', {
    staticClass: "epigraph"
  }, [_vm._v("Trust in the L"), _c('span', {
    staticClass: "small_caps"
  }, [_vm._v("ord")]), _vm._v(" with all your heart;\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "epigraph"
  }, [_vm._v("do not depend on your own understanding.")]), _vm._v(" "), _c('p', {
    staticClass: "epigraph_attribution"
  }, [_vm._v("Proverbs 3:5")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2eba9634","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Epigraph.vue
// module id = 63
// module chunks = 0